import React, { useEffect } from 'react'

import { GetStaticPropsContext } from 'next'
import styled from 'styled-components'

import { FlexContainer } from '@/components'
import { HeadTag } from '@/components/headTag'
import {
  CasesContainer,
  HeroContainer,
  GlassdoorContainer,
  PartnersContainer,
  ServicesContainer,
} from '@/containers'
import { ReviewContainer } from '@/containers/reviews'
import { getHomeData, HomePage } from '@/service/api/home'
import { Constants } from '@/utils/constants'
import { withFooterHeader } from '@/utils/withFooterHeader'
import { withPageStaticProps } from '@/utils/withPageStaticProps'

type HomeProps = {
  data: HomePage
}

const FlexContainerHome = styled(FlexContainer)`
  max-width: 100%;
`

const Home: React.FC<HomeProps> = ({
  data: { hero, services, partners, cases, glassdoor, reviews, seo },
}) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <HeadTag
        languageOptions={['en']}
        path="/"
        title={seo?.metaTitle}
        description={seo?.metaDescription}
        image={seo?.metaImage}
      />
      <FlexContainerHome direction="column" padding="0" data-testid="main">
        {hero && <HeroContainer heroData={hero} />}
        {services && <ServicesContainer servicesData={services} />}
        <div style={{ height: 112 }} />
        {partners && <PartnersContainer partnerData={partners} />}
        <div style={{ height: 112 }} />
        {cases && <CasesContainer darkMode data={cases} />}
        {reviews && <ReviewContainer cards={reviews.cards} />}
        <div style={{ height: 112 }} />
        {glassdoor && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: 'white',
              paddingBottom: '112px',
            }}
          >
            <GlassdoorContainer glassdoorData={glassdoor} />
          </div>
        )}
      </FlexContainerHome>
    </>
  )
}

export const getStaticProps = withPageStaticProps(
  async (context: GetStaticPropsContext) => {
    const data = await getHomeData(String(context.locale))

    return {
      props: {
        data,
      },
      revalidate: Constants.ONE_DAY,
    }
  },
)

export default withFooterHeader(Home)
